import { useFormatter, useTranslations } from 'next-intl';

import { I18nLegacy, UiLegacy } from '@silvertours/front-legacy-shared';

import { AverageRating, SummaryContainer } from './Reviews.styles';

type FeedbackSummaryProps = {
  averageRating: number;
  count: number;
  locationName?: string;
  hideSummaryDescription?: boolean;
};

const { important } = I18nLegacy;

const FeedbackSummary = ({
  averageRating,
  count,
  hideSummaryDescription = false,
  locationName = '',
}: FeedbackSummaryProps) => {
  const format = useFormatter();
  const t = useTranslations('features.trustLegacy.feedback.feedbackGroup');
  const title = t('title.seo');
  const description = t('description');
  const descriptionLocation = t.rich('descriptionLocation', {
    locationName,
    important,
  });
  const reviewCountLabel = t.rich('reviewCountLabel', {
    count: format.number(count, { useGrouping: 'auto' }),
    important,
  });
  const averagePercentLabel = t('averagePercentLabel');

  return (
    <SummaryContainer>
      <UiLegacy.SectionTitle>{title}</UiLegacy.SectionTitle>
      {!hideSummaryDescription && (
        <AverageRating>
          <UiLegacy.CalloutText>
            {locationName ? descriptionLocation : description}
          </UiLegacy.CalloutText>
          <UiLegacy.PlainText>{reviewCountLabel}</UiLegacy.PlainText>
          <UiLegacy.PlainText>
            <UiLegacy.Rating value={averageRating} />
            {averagePercentLabel}
          </UiLegacy.PlainText>
        </AverageRating>
      )}
    </SummaryContainer>
  );
};

export { FeedbackSummary };
